<template>
  <div ref="formStepper" class="form-stepper">
    <slot />
  </div>
</template>

<script>
export default {
  provide() {
    const stepperContext = {};

    Object.defineProperty(stepperContext, 'stepIndex', {
      enumerable: true,
      get: () => this.stepIndex,
    });

    Object.defineProperty(stepperContext, 'stepAmount', {
      enumerable: true,
      get: () => this.stepAmount,
    });

    Object.defineProperty(stepperContext, 'advanceStep', {
      enumerable: true,
      get: () => this.advanceStep,
    });

    Object.defineProperty(stepperContext, 'registerStep', {
      enumerable: true,
      get: () => this.registerStep,
    });

    Object.defineProperty(stepperContext, 'performInitialGetRequest', {
      enumerable: true,
      get: () => this.performInitialGetRequest,
    });

    return {
      stepperContext,
    };
  },
  props: {
    advanceStepCallback: {
      type: Function,
      default() {
        return () => false;
      },
    },
    startAtIndex: {
      type: Number,
      default: undefined,
    },
    performInitialGetRequest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stepIndex: 0,
      stepAmount: 0,
    };
  },
  mounted() {
    if (this.startAtIndex >= 0) this.stepIndex = this.startAtIndex;
  },
  methods: {
    advanceStep() {
      this.stepIndex++;
      if (!this.advanceStepCallback) return;
      this.$nextTick(() => {
        this.advanceStepCallback();
      });
    },
    registerStep() {
      this.stepAmount++;
    },
  },
};
</script>
